<ng-container *ngIf="item; else skeleton">
  <div class="item-box" (click)="onClickItem()" [style.padding-top]="100 / ratio + '%'">
    <div class="item-con">
      <span>{{ item.labelName }}</span>
    </div>
  </div>
</ng-container>
<ng-template #skeleton>
  <div class="item-box skeleton-loading" [style.padding-top]="100 / ratio + '%'"></div>
</ng-template>
